module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "ليث-حجازين"
    }
  }, [_c('h1', [_vm._v("ليث حجازين")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليث حجازين شاب من الطبقة العادية ولكنه طَمُوح في بلد يقبر الطُمُوح، ثابر ليفعل شيئاً ويغير واقعه ففشل كثيراً. وصل للقاع وخسر كل شيء مهم تقريباً، ومع هذا لم يستسلم بل حاول وحاول مراراً وتكراراً، فكتب كتاب تحفيز يعبر فيه باختصار عن معركته في الحياة وشارك القارئ في بعض ما وصل إليه من أرض معرفة عذراء، عن معركة تغيير القدر ورفع جودة الحياة أتحدث.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 63
// module chunks = 0